<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12>
				<v-tabs grow class="checkin-tabs pos-tabs" v-model="active">
					<v-tabs-bar class="transparent">
						<v-tabs-slider class="default-skyblue"></v-tabs-slider>
						<v-tabs-item
							v-for="item in items"
							:key="item.id"
							:href="'#tab-' + item.id"
							:disabled="$v.model.$invalid && (item.id === 2)">
							{{ item.title }}
						</v-tabs-item>
					</v-tabs-bar>
					<v-tabs-items>
						<v-tabs-content
							v-for="i in items.length"
							:key="i"
							:id="'tab-' + i">
							<v-layout row wrap
								v-if="i === 1" my-4>
								<v-flex xs12 text-xs-left mb-2>
									<label class="label-title">Completa los datos</label>
								</v-flex>
								<v-flex xs12 text-xs-left>
									<v-layout row wrap>
										<v-flex xs3>
											<label class="label-form">Buscar por</label>
											<v-select
												class="filter-select"
												:items="searchMethods"
												item-text="name"
												item-value="id"
												label="Buscar por..."
												v-model="searchBy"
												hide-details
												single-line
												bottom
												@input="cleanModel('search')">
											</v-select>
										</v-flex>
										<v-flex xs3 mb-3>
											<label class="label-form">Sucursal</label>
											<v-select
												class="filter-select"
												label="Elige la sucursal"
												:items="subsidiaries"
												item-text="name"
												item-value="id"
												v-model.number="subsidiary"
												hide-details
												single-line
												bottom
												@input="cleanModel">
											</v-select>
										</v-flex>
										<v-flex xs3 mb-3 v-if="searchByRoom">
											<label class="label-form">Nº de Habitación</label>
											<v-text-field
												type="number"
												class="input-border-inset"
												placeholder="Nº"
												v-model.number="roomFilter"
												:disabled="roomDisabled"
												@blur="searchCustomerByRoom">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.roomFilter && $v.roomFilter.$invalid">
												El número de habitación es requerido
											</span>
										</v-flex>
										<v-flex xs3 mb-3>
											<label class="label-form">Tipo de identificación</label>
											<type-document-input
												@customer-data="getCustomerData"
												@customer-not-found="notFoundCustomer"
											/>
											<span class="caption red--text"
												v-if="$v.model.numDocument && $v.model.numDocument.$invalid">
												El número de documento es requerido
											</span>
											<p class="caption red--text mb-0"
												v-if="$v.model.numDocument && $v.model.numDocument.$invalid
													&& $v.model.numDocument.$params.minLength">
												Es necesario ingresar {{ $v.model.numDocument.$params.minLength.min }} dígitos
											</p>
										</v-flex>
										<v-flex xs3 v-show="searchById">
											<label class="label-form">Nº de Habitación</label>
											<v-select
												class="filter-select"
												:items="bookings"
												item-text="codeRoom"
												item-value="id"
												v-model="model.idRoom"
												:disabled="!model.numDocument
													|| roomsEmpty"
												hide-details
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs3 mb-3 :class="{ 'xs6' : !naturalPerson }">
											<label class="label-form">{{ nameLabel }}</label>
											<v-text-field
												type="text"
												class="input-border-inset"
												:disabled="!model.numDocument"
												v-model="model.name">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.model.name && $v.model.name.$invalid">
												{{ nameMessage }}
											</span>
										</v-flex>
										<v-flex xs3 mb-3 v-if="naturalPerson">
											<label class="label-form">Apellidos</label>
											<v-text-field
												type="text"
												class="input-border-inset"
												placeholder="Completos"
												:disabled="!model.numDocument"
												v-model="model.lastname">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.model.lastname && $v.model.lastname.$invalid">
												El apellido es requerido
											</span>
										</v-flex>
										<v-flex xs3 mb-3>
											<label class="label-form">Correo electrónico</label>
											<v-text-field
												type="email"
												class="input-border-inset"
												placeholder="nombre@mail.com"
												:disabled="!model.numDocument"
												v-model="model.email">
											</v-text-field>
										</v-flex>
										<v-flex xs3 mb-3>
											<label class="label-form">Celular</label>
											<v-text-field
												type="number"
												class="input-border-inset"
												:disabled="!model.numDocument"
												v-model="model.cellPhone">
											</v-text-field>
										</v-flex>

										<v-flex xs3 mb-3>
											<label class="label-form">Fecha de nacimiento</label>
											<v-menu
												lazy
												v-model="dateBirthPos"
												:nudge-left="40"
												transition="scale-transition"
												offset-y
												full-width
												class="menu-date-picker"
												max-width="290px">
												<v-text-field
													slot="activator"
													label="Fecha de nacimiento"
													v-model="dateBirthPosStart"
													:disabled="!dateBirthPosStart"
													:append-icon="arrowIconStart"
													single-line
													hide-details
													readonly
												></v-text-field>
												<v-date-picker
													v-model="dateBirthPosStart"
													no-title
													year-icon
													scrollable
													>
												</v-date-picker>
											</v-menu>
										</v-flex>
										
										<v-flex xs3 mb-3 v-if="naturalPerson">
											<label class="label-form">Género</label>
											<v-select
												class="filter-select"
												item-text="name"
												item-value="id"
												:items="genders"
												v-model="model.gender"
												hide-details
												:disabled="!model.numDocument"
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs3 mb-3 v-if="naturalPerson">
											<label class="label-form">Estado civil</label>
											<v-select
												class="filter-select"
												item-text="name"
												item-value="id"
												:items="civilStatus"
												v-model="model.civilStatus"
												hide-details
												:disabled="!model.numDocument"
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs3>
											<label class="label-form">País</label>
											<v-select
												autocomplete
												class="filter-select filter-select-autocomplete"
												:items="countries"
												item-text="name"
												item-value="id"
												v-model="model.countryId"
												hide-details
												:disabled="!model.numDocument"
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs6 mb-3>
											<label class="label-form">Dirección</label>
											<v-text-field
												type="text"
												class="input-border-inset"
												:disabled="!model.numDocument"
												v-model="model.address">
											</v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12>
									<v-layout row wrap align-center justify-end>
										<v-flex xs2>
											<v-btn
												type="button"
												info
												class="btn-action back"
												@click="goToSummary">
												Anónimo
											</v-btn>
										</v-flex>
										<v-flex xs2 v-if="roomsEmpty && searchById && !customerExist">
											<v-btn
												:disabled="$v.model.$invalid"
												info
												class="btn-action back"
												type="button"
												@click="register">
												Registrar
											</v-btn>
										</v-flex>
										<v-flex xs2 v-else>
											<v-btn
												:disabled="$v.model.$invalid"
												info
												class="btn-action back"
												type="button"
												@click="goToCheckout">
												Continuar
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
							<v-layout row wrap align-center
								v-else my-4>
								<v-flex xs9>
									<v-layout row wrap align-center>
										<v-flex xs3>
											<v-btn
												type="button"
												class="btn-action btn-success white--text"
												@click.native.stop="openProductsModal">
												<v-icon>add</v-icon> Agregar
											</v-btn>
											<payment-dialog
												v-model="dialog"
												@products-to-pay="updateProducts"
												@close-modal="dialog = false"
											/>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs3>
									<label class="total-amount">
										Total {{ totalAmount | round | currency(symbol) }}
									</label>
								</v-flex>
								<v-flex xs12 my-2>
									<v-divider></v-divider>
								</v-flex>
								<v-flex xs12 pb-0>
									<table-run
										:columns="summaryColumns"
										:rows="localSummaryRows"
										:include-delete="false"
										:include-delete-single="false"
										:include-export-to-excel="false"
										:include-options="false"
										:include-search="false"
										:include-switch="false"
										:include-settings="false"
										:selectable="false"
										class="no-selectable-table">
										<template slot="rows" scope="props">
											<td>{{ props.row.createdAt | parseDate }}</td>
											<td>{{ props.row.code }}</td>
											<td>{{ props.row.quantity }}</td>
											<td>{{ props.row.name }}</td>
											<td>{{ props.row.subTotal | round | currency(symbol) }}</td>
											<td>
												<v-btn
													icon
													class="error--text"
													@click="deleteLocalProduct(props.row)"
												>
													<v-icon>delete</v-icon>
												</v-btn>
											</td>
										</template>
									</table-run>
								</v-flex>
								<v-flex xs12>
									<v-layout row wrap justify-center my-3>
										<v-flex xs2 pr-2>
											<v-btn
												info
												class="btn-action back"
												type="button"
												@click="back">
												Volver
											</v-btn>
										</v-flex>
										<v-flex xs2 pl-2>
											<v-btn
												type="button"
												class="btn-action btn-success white--text"
												:disabled="saleDisabled"
												@click.native.stop="openSaleModal">
												Cobrar
											</v-btn>
											<v-dialog
												v-model="saleModal"
												persistent
												width="850px">
												<v-card height="auto" class="pb-5">
													<v-card-title class="headline">
														Ventas
													</v-card-title>
													<v-layout row wrap align-center>
														<v-flex xs12 mb-4>
															<v-divider></v-divider>
														</v-flex>
														<v-flex xs12 mb-2 pl-2 v-if="billingActive">
															<v-checkbox
																class="input-checkbox input-booking"
																label="Exonerar impuestos"
																v-model="flagTaxes"
																color="info"
																hide-details
																@change="validateExoneration">
															</v-checkbox>
														</v-flex>
														<v-flex xs12 mb-2>
															<v-layout row wrap align-center>
																<v-flex xs2>
																	<label class="label-sale-modal">Tipo de documento</label>
																</v-flex>
																<v-flex xs4>
																	<v-radio-group
																		v-model="saleModel.typeDocumentCode"
																		v-if="documentTypes.length > 0"
																		@change="setTypeDocument"
																		row>
																		<v-radio
																			class="sale-radio-button"
																			color="info"
																			:label="documentTypes[0].documentType.name"
																			:value="documentTypes[0].documentType.code">
																		</v-radio>
																		<v-radio
																			class="sale-radio-button"
																			color="info"
																			:disabled="cantBilling"
																			:label="documentTypes[1].documentType.name"
																			:value="documentTypes[1].documentType.code"
																		>
																		</v-radio>
																		<v-radio
																			class="sale-radio-button"
																			color="info"
																			:label="documentTypes[2].documentType.name"
																			:value="documentTypes[2].documentType.code"
																		>
																		</v-radio>
																	</v-radio-group>
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 mb-3>
															<v-layout wrap align-center>
																<v-flex xs2 pl-3 text-xs-left>
																	<label class="label-sale-modal">
																		Tipo de cambio
																	</label>
																</v-flex>
																<v-flex xs2 pr-3>
																	<v-text-field
																		type="text"
																		class="input-border-inset"
																		v-model="exchangeRate"
																		@blur="changeAmounts(currencySelected)"
																		@keyup.enter="changeAmounts(currencySelected)">
																	</v-text-field>
																</v-flex>
																<v-flex xs2>
																	<v-select
																		class="filter-select"
																		item-text="code"
																		item-value="code"
																		label="Moneda"
																		:items="currencies"
																		v-model="currencySelected"
																		hide-details
																		single-line
																		bottom
																		@input="changeAmounts"
																	>
																	</v-select>
																</v-flex>
																<v-flex mb-3>
																<v-layout wrap align-center justify-end>
																			<v-flex xs4 text-xs-right pr-3
																				>
																				<label class="label-form">Recargo al Consumo</label>
																				<v-text-field
																					type="number"
																					class="input-border-inset"
																					v-model="tip"
																					>
																				</v-text-field>
																			</v-flex>
																		</v-layout>
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 pr-3>
															<v-layout row wrap>
																<v-flex xs2 pl-3>
																	<v-select
																		class="filter-select"
																		item-text="name"
																		item-value="code"
																		label="Modo de pago"
																		:items="paymentMethods"
																		v-model="saleModel.paymentMethodCode"
																		@input="setPaymentMethod"
																		hide-details
																		single-line
																		bottom>
																	</v-select>
																</v-flex>
																<v-flex xs10 pl-3>
																	<v-select
																		chips
																		class="filter-select filter-select-multiple"
																		hide-details
																		item-text="name"
																		item-value="code"
																		:disabled="invalid"
																		:items="typePayments"
																		label="Selecciona los tipos de pago a realizar"
																		multiple
																		return-object
																		single-line
																		v-model="typePaymentsSelected"
																		@input="addPays"
																	>
																	</v-select>
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 px-3 mt-3>
															<v-layout wrap>
																<v-flex xs2 text-xs-left pr-2
																	v-for="pay in paysByTypePayment"
																	:key="pay.code"
																>
																	<label class="label-form">{{ pay.name }}</label>
																	<v-text-field
																		type="number"
																		class="input-border-inset"
																		v-model.number="pay.amount">
																	</v-text-field>
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 mt-3>
															<div class="bar-data">
																<div class="bar-data-item">
																	<p>
																		Cliente:
																		<span>{{ model.name }}</span>
																	</p>
																</div>
																<div class="bar-data-item">
																	<p>
																		{{ documentTypeName }}:
																		<span>{{ model.numDocument }}</span>
																	</p>
																</div>
																<div class="bar-data-item">
																	<p>
																		Tipo de Documento:
																		<span>{{ saleCustomer.typeDocument }}</span>
																	</p>
																</div>
																<div class="bar-data-item">
																	<p>
																		Modo de pago:
																		<span>{{ saleCustomer.paymentMethod }}</span>
																	</p>
																</div>
																<div class="bar-data-item">
																	<p>
																		Moneda:
																		<span>{{ currencySelected }}</span>
																	</p>
																</div>
															</div>
														</v-flex>
														<v-flex xs12 mt-3>
															<table-run
																class="no-selectable-table"
																:columns="localProductsColumns"
																:rows="localSummaryRows"
																:include-delete="false"
																:include-export-to-excel="false"
																:include-options="false"
																:include-search="false"
																:include-switch="false"
																:include-settings="false"
																:include-delete-single="false"
																:selectable="false">
																<template slot="rows" scope="props">
																	<td>{{ props.row.createdAt | parseDate }}</td>
																	<td>{{ props.row.code }}</td>
																	<td>{{ props.row.categoryName }}</td>
																	<td>{{ props.row.name }}</td>
																	<td>{{ props.row.quantity }}</td>
																	<td>
																		{{ symbol }} <input type="number" v-model.number="props.row.subTotal" />
																		<v-btn
																			icon
																			class="warning--text"
																			v-if="props.row.flagIgvRequired"
																			v-tooltip:top="{ html: 'Impuesto obligatorio' }"
																		>
																			<v-icon>
																				warning
																			</v-icon>
																		</v-btn>
																	</td>
																</template>
															</table-run>
														</v-flex>
													</v-layout>
													<v-layout wrap mt-2>
														<v-flex xs12 px-3 text-xs-left>
															<label>Observación:</label>
															<v-text-field
																class="input-border-inset input-textarea input-note mt-1"
																no-resize
																multi-line
																placeholder="Escriba aquí"
																:rows="2"
																textarea
																v-model="commentary"
															></v-text-field>
														</v-flex>
													</v-layout>
													<v-card-actions>
														<v-layout row wrap my-3
															align-end
															justify-center>
															<v-flex xs2 pr-2>
																<v-btn
																	type="button"
																	primary
																	class="btn-action"
																	@click.native="closeSaleModal">
																	Cancelar
																</v-btn>
															</v-flex>
															<v-flex xs2 pl-2>
																<v-btn
																	class="btn-action btn-success white--text"
																	:disabled="$v.saleCustomer.$invalid
																		|| disableGenerateSale || validateAmount
																		|| invalid || disabledSave"
																	@click.native="generateSale">
																	Guardar
																</v-btn>
															</v-flex>
															<v-flex xs2 pl-3>
																	<v-btn
																		:disabled="$v.saleCustomer.$invalid
																		|| validateAmount"
																		class="btn-action btn-darkblue white--text"
																		@click.native="postPreview"
																	>
																	Previsualización
																</v-btn>
															</v-flex>
														</v-layout>
													</v-card-actions>
												</v-card>
											</v-dialog>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-tabs-content>
					</v-tabs-items>
				</v-tabs>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import { email, maxLength, minLength, minValue, required, requiredIf } from 'vuelidate/lib/validators';
	import { format, isDate, subYears } from 'date-fns';
	import TableRun from 'table-run';
	import mixin from '@/shared/mixins';
	import lib from '@/shared/lib';
	import { currency, parseDate, round } from '@/shared/filters';
	import typeDocumentInput from '@/clerkinn/shared/type-document-input';
	import PaymentDialog from '@/clerkinn/shared/payment-dialog';
	import helper from '@/shared/helper';

	const { decimals } = lib;
	const twoDecimals = decimals(2);
	const helperMethods = helper.methods;

	function created() {
		this.loadResources();
		this.loadCurrencies();
		this.loadExchangeRate();
	}

	async function postPreview() {
		const dataModel = {
			commentary: this.commentary,
			currency: this.currencySelected,
			exchangeRate: this.exchangeRate,
			flagTaxes: this.flagTaxes,
			paymentMethodCode: this.saleModel.paymentMethodCode,
			subsidiaryId: this.subsidiary,
			tip: this.tip,
			transactions: this.paysByTypePayment.map((pays) => {
				const newPays = {
					amount: pays.amount,
					currency: this.currencySelected,
					paymentAmount: pays.amount,
					paymentDate: format(new Date(), 'YYYY-MM-DD'),
					typePaymentId: pays.id,
				};
				return newPays;
			}),
			transactionId: this.typePaymentsSelected.map(typePay => typePay.id),
			typeDocumentCode: this.saleModel.typeDocumentCode,
			typePaymentCode: this.saleModel.typePaymentCode,
		};
		dataModel.details = this.localSummaryRows.map((local) => {
			const newLocal = { ...local };
			newLocal.detail = {
				brandId: local.brandId,
				categoryId: local.categoryId,
				code: local.code,
				discount: 0,
				discountPorcent: local.discount,
				flagIgv: local.flagIgv,
				flagIgvRequired: local.flagIgvRequired,
				igvId: local.igvId,
				name: local.name,
				price: local.subTotal,
				productType: local.productType,
				stockQuantity: local.stockQuantity,
				quantity: local.quantity,
				warProductsId: local.warProductsId,
				warWarehousesId: local.warWarehousesId,
				priceSoles: local.priceSoles,
				unitId: local.unitId,
				unitCode: local.unitCode,
				categoryName: local.categoryName,
			};
			return newLocal.detail;
		});
		if (this.anonymousCustomer) {
			dataModel.customerId = null;
		} else {
			dataModel.customerId = this.model.id || this.customerId;
		}
		try {
			const baseUrl = process.env.PMS_URL;
			const params = { recipe: 'phantom-pdf' };
			const responseType = 'blob';
			const response = await this.$http.post(`${baseUrl}/report/document-previous`, dataModel,
			{ params, responseType });
			const blob = helperMethods.generateBlob(response.bodyBlob);
			helperMethods.showDownloadDialog(blob, 'PREVISUALIZACIÓN DE DOCUMENTO', 'pdf', true);
		} catch (err) {
			if (err.status === 404) {
				if (err.data.message === 'CUSTOMER_NOT_FOUND') {
					this.showNotification('No se puede crear factura con un cliente anónimo, ingrese la información del cliente o genere una boleta.',
						'warning');
				}
			}
		}
	}

	function addPays(paymentsType) {
		this.paysByTypePayment = paymentsType.map((pay) => {
			const newAmount = this.totalAmount / paymentsType.length;
			const newPay = {
				amount: newAmount.toFixed(2),
				code: pay.code,
				id: pay.id,
				name: pay.name,
			};
			return newPay;
		});
	}

	function arrowIconBirth() {
		const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function back() {
		this.active = 'tab-1';
	}

	function billingActive() {
		return this.saleModel.typeDocumentCode === 'FAC' && !this.cantBilling;
	}

	function cantBilling() {
		return this.naturalPerson && this.model.documentType !== 2
			&& this.model.documentType !== 4 && this.model.documentType !== 5;
	}

	function addLocalTaxes(number, igv = 1.18) {
		return Number(number) * igv;
	}

	function arrowIconStart() {
		const arrow = this.dateBirthPos ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function changeAmounts(currencyCode) {
		this.localSummaryRows = this.summaryRows.map((sr) => {
			const newSr = { ...sr };
			let price = 0;
			if (currencyCode === 'USD') {
				if (sr.flagIgv && !sr.flagIgvRequired) {
					price = sr.price ? sr.price : sr.subTotal;
				} else {
					price = sr.price ? addLocalTaxes(sr.price) : addLocalTaxes(sr.subTotal);
				}
			}
			if (currencyCode === 'PEN') {
				if (sr.flagIgv && !sr.flagIgvRequired) {
					price = sr.priceSoles ? sr.priceSoles : Number(sr.price) * Number(this.exchangeRate);
				} else {
					price = sr.priceSoles
						? addLocalTaxes(sr.priceSoles)
						: addLocalTaxes(Number(sr.price) * Number(this.exchangeRate));
				}
			}
			newSr.subTotal = Math.round(price * 100) / 100;
			return newSr;
		});
	}

	function changeIcon(result) {
		this.onChange = result;
	}

	function cleanModel(code) {
		this.model = {
			address: '',
			cellPhone: '',
			checkIn: '',
			checkOut: '',
			civilStatus: 1,
			countryId: 0,
			dateBirthPosStart: format(subYears(new Date(), 18), 'YYYY-MM-DD'),
			documentType: 1,
			email: '',
			flagLoyalty: false,
			gender: 1,
			idRoom: 0,
			lastname: '',
			name: '',
			numDocument: '',
			phone: '',
			priceSoles: '',
		};
		if (code === 'search') {
			this.roomFilter = 0;
		}
	}

	function cleanCustomer(code) {
		this.model.cellPhone = '';
		this.model.address = '';
		this.model.checkIn = '';
		this.model.checkOut = '';
		this.model.civilStatus = 1;
		this.model.countryId = 0;
		this.model.dateBirthPosStart = format(subYears(new Date(), 18), 'YYYY-MM-DD');
		this.model.email = '';
		this.model.flagLoyalty = false;
		this.model.gender = 1;
		this.model.idRoom = 0;
		this.model.lastname = '';
		this.model.name = '';
		this.model.phone = '';
		this.model.priceSoles = '';
		this.bookings = [];
		if (code === 'by-room') {
			this.model.numDocument = '';
		}
	}

	function closeSaleModal() {
		this.saleModal = false;
	}

	function deleteLocalProduct({ id }) {
		const summaryIndex = this.localSummaryRows.findIndex(summary => summary.id === id);
		this.localSummaryRows.splice(summaryIndex, 1);
		this.summaryRows.splice(summaryIndex, 1);
	}

	function disableGenerateSale() {
		return this.paysByTypePayment.length === 0
			&& this.paysByTypePayment.some(payByType => !payByType.amount);
	}

	function disabledId() {
		return (this.searchByRoom && (this.roomFilter <= 0))
			|| (this.searchByRoom && !this.model.numDocument)
			|| (this.searchById && (this.subsidiary <= 0));
	}

	function disabledSave() {
		return this.saleModel.typeDocumentCode === 'FAC' && this.cantBilling;
	}

	function documentTypeName() {
		const docType = this.typeDocuments.find(doc => doc.id === this.model.documentType) || {};
		return docType.name;
	}

	async function generateSale() {
		const dataModel = {
			commentary: this.commentary,
			currency: this.currencySelected,
			exchangeRate: this.exchangeRate,
			flagTaxes: this.flagTaxes,
			paymentMethodCode: this.saleModel.paymentMethodCode,
			subsidiaryId: this.subsidiary,
			tip: this.tip,
			transactions: this.paysByTypePayment.map((pays) => {
				const newPays = {
					amount: pays.amount,
					currency: this.currencySelected,
					paymentAmount: pays.amount,
					paymentDate: format(new Date(), 'YYYY-MM-DD'),
					typePaymentId: pays.id,
				};
				return newPays;
			}),
			transactionId: this.typePaymentsSelected.map(typePay => typePay.id),
			typeDocumentCode: this.saleModel.typeDocumentCode,
			typePaymentCode: this.saleModel.typePaymentCode,
		};
		dataModel.details = this.localSummaryRows.map((local) => {
			const newLocal = { ...local };
			newLocal.detail = {
				brandId: local.brandId,
				categoryId: local.categoryId,
				code: local.code,
				discount: 0,
				discountPorcent: local.discount,
				flagIgv: local.flagIgv,
				flagIgvRequired: local.flagIgvRequired,
				igvId: local.igvId,
				name: local.name,
				price: local.subTotal,
				productType: local.productType,
				stockQuantity: local.stockQuantity,
				quantity: local.quantity,
				warProductsId: local.warProductsId,
				warWarehousesId: local.warWarehousesId,
				priceSoles: local.priceSoles,
				unitId: local.unitId,
				unitCode: local.unitCode,
				categoryName: local.categoryName,
			};
			return newLocal.detail;
		});
		if (this.anonymousCustomer) {
			dataModel.customerId = null;
		} else {
			dataModel.customerId = this.model.id || this.customerId;
		}
		try {
			const { data: newSale } = await this.$http.post(`${process.env.PMS_URL}/point/sales`, dataModel);
			this.showNotification('La venta se completó correctamente.', 'success');
			this.saleModal = false;
			if (newSale) {
				if (this.saleModel.typeDocumentCode === 'COT') {
					this.downloadTicket(newSale.data);
				}
				this.$router.push({ name: 'sale-detail', params: { id: newSale.data.saleId } });
			}
		} catch (err) {
			if (err.status === 404) {
				if (err.data.message === 'CUSTOMER_NOT_FOUND') {
					this.showNotification('No se puede crear factura con un cliente anónimo, ingrese la información del cliente o genere una boleta.',
						'warning');
				}
			}
		}
	}

	async function downloadTicket({ saleId, documentNumber }) {
		const urlBase = `${process.env.PMS_URL}/report/command-preview`;
		const query = `?format=tabloid&recipe=html-with-browser-client&documentId=${saleId}`;
		const name = `${documentNumber}`;
		const response = await this.$http.post(
			`${urlBase}${query}`,
		);
		const blob = helperMethods.generateBlob(response.bodyText);
		helperMethods.showDownloadDialog(blob, name, 'html');
	}

	function goToCheckout() {
		this.anonymousCustomer = false;
		if (this.model.idRoom > 0) {
			const booking = this.searchById ?
				this.bookings.find(room => room.id === this.model.idRoom) : this.bookings[0];
			const query = {
				initDate: format(booking.bookingStart, 'YYYY-MM-DD'),
				endDate: format(booking.bookingEnd, 'YYYY-MM-DD'),
				roomId: this.model.idRoom,
				bookingCode: booking.code,
				active: 'tab-2',
			};
			this.$router.push({
				name: 'checkin-form-tabs',
				params: {
					hotelId: this.subsidiary,
					roomTypeId: this.searchById ? booking.roomTypeId : booking.entityId,
				},
				query,
			});
		} else {
			this.goToTab();
		}
	}

	function goToSummary() {
		this.active = `tab-${this.items[(this.items.indexOf(row =>
			`tab-${row.id}` === this.active) + 2) % this.items.length].id}`;
		this.anonymousCustomer = true;
	}

	function goToTab() {
		this.active = `tab-${this.items[(this.items.indexOf(row =>
			`tab-${row.id}` === this.active) + 2) % this.items.length].id}`;
	}

	async function loadCurrencies() {
		const { data: currencies } = await this.$http.get(`${process.env.PMS_URL}/currency`);
		this.currencies = currencies.data;
		this.currencySelected = currencies.data.find(cur => cur.id === 'USD').code;
	}

	async function loadExchangeRate() {
		const today = format(new Date(), 'YYYY-MM-DD');
		const { data: exchangeRate } = await this.$http.get(`${process.env.PMS_URL}/exchange-rates/${today}`);
		this.exchangeRate = exchangeRate.data.amount;
	}

	async function loadResources() {
		const request = [
			this.$http.get(`${process.env.PMS_URL}/hotel`),
			this.$http.get(`${process.env.PMS_URL}/countries`),
			this.$http.get(`${process.env.PMS_URL}/documents-type`),
		];
		const [subsidiaries, countries, typeDocuments] = await Promise.all(request);
		this.subsidiaries = subsidiaries.data.data;
		this.countries = countries.data.data;
		this.subsidiary = this.subsidiaries[0].id;
		this.typeDocuments = typeDocuments.data.data;
		this.model.documentType = 1;
	}

	async function loadSaleResources() {
		const request = [
			this.$http.get(`${process.env.SALES_URL}/p/type-documents`),
			this.$http.get(`${process.env.SALES_URL}/p/type-payments`),
		];
		const [documents, payments] = await Promise.all(request);
		const typeDocumentsModified = documents.data.map((doc) => {
			const newDoc = { ...doc };
			if (doc.documentType.code === 'COT') {
				newDoc.documentType.name = 'COMANDA';
			}
			return newDoc;
		});
		this.documentTypes[0] = typeDocumentsModified.find(tdm => tdm.documentType.code === 'BOL');
		this.documentTypes[1] = typeDocumentsModified.find(tdm => tdm.documentType.code === 'FAC');
		this.documentTypes[2] = typeDocumentsModified.find(tdm => tdm.documentType.code === 'COT');
		this.typePayments = payments.data.map((pay) => {
			const newPay = Object.assign({}, pay);
			newPay.payment = pay.paymentType;
			return newPay.payment;
		});
		this.saleModel.typePaymentCode = 'efectivo';
	}

	function nameLabel() {
		return this.naturalPerson ? 'Nombres' : 'Razón Social';
	}

	function nameMessage() {
		return this.naturalPerson ? 'El nombre es requerido' : 'La razón social es requerida';
	}

	function naturalPerson() {
		return this.model.documentType < 4 || this.model.documentType === 5;
	}

	function numDocumentLength() {
		if (this.model.documentType === 1) {
			return 8;
		} else if (this.model.documentType === 4) {
			return 11;
		}
		return 0;
	}

	function openProductsModal() {
		this.dialog = true;
	}

	function openSaleModal() {
		this.loadSaleResources();
		this.saleCustomer.paymentMethod = this.saleModel.paymentMethodCode;
		this.saleModal = true;
		if (this.saleModel.typeDocumentCode === 'FAC') {
			this.showError();
		}
	}

	async function register() {
		const modelSend = {
			name: this.model.name,
			lastname: this.model.lastname,
			documentType: this.model.documentType,
			numDocument: this.model.numDocument,
			email: this.model.email,
			civilStatus: this.model.civilStatus,
			dateBirthPosStart: this.dateBirthPosStart,
			address: this.model.address,
			gender: this.model.gender,
			cellPhone: this.model.cellPhone,
			countryId: this.model.countryId,
			priceSoles: this.model.priceSoles,
		};
		const { data: customer } = await this.$http.post(`${process.env.PMS_URL}/customers`, modelSend);
		this.showNotification('El cliente ha sido registrado.', 'success');
		this.customerId = customer.data.id;
		this.active = 'tab-2';
	}

	function roomDisabled() {
		return this.subsidiary <= 0;
	}

	function roomsEmpty() {
		return this.bookings.length <= 0;
	}

	function saleDisabled() {
		return this.localSummaryRows.length === 0;
	}

	function searchById() {
		return this.searchBy === 1;
	}

	async function searchByMixin() {
		const { data: customer } = await this.mixinSearchCustomer(this.model.documentType,
			this.model.numDocument);
		this.bookings = customer.data.bookingRooms ? customer.data.bookingRooms : [];
		delete customer.data.bookingRooms;
		const newCustomer = {
			address: customer.data.domicilio,
			cellPhone: '',
			checkIn: '',
			checkOut: '',
			civilStatus: 0,
			countryId: process.env.DEFAULT_COUNTRY_ID,
			dateBirthPosStart: customer.data.fecha_inscripcion
				&& customer.data.fecha_inscripcion !== '0000-00-00'
				&& isDate(new Date(customer.data.fecha_inscripcion)) ?
				customer.data.fecha_inscripcion :
				format(subYears(new Date(), 18), 'YYYY-MM-DD'),
			documentType: 4,
			email: '',
			flagLoyalty: false,
			gender: 0,
			idRoom: 0,
			lastname: '',
			name: customer.data.nombre,
			numDocument: customer.data.ruc,
			phone: customer.data.telefono,
		};
		this.model = { ...newCustomer };
	}

	function searchByRoom() {
		return this.searchBy === 2;
	}

	async function searchCustomer() {
		const paramsCustomer = {
			numDocument: this.model.numDocument,
			documentType: this.model.documentType,
			idSubsidiary: this.subsidiary,
			date: format(new Date(), 'YYYY-MM-DD'),
		};
		if (this.model.numDocument !== '' && this.roomFilter <= 0) {
			try {
				const { data: customer } = await this.$http.get(`${process.env.PMS_URL}/bookings-customer`,
					{ params: paramsCustomer });
				customer.data.idRoom = 0;
				this.bookings = customer.data.bookingRooms ? customer.data.bookingRooms : [];
				delete customer.data.bookingRooms;
				this.model = customer.data;
				this.model.countryId = customer.data.country && customer.data.country.data.id ?
					customer.data.country.data.id : process.env.DEFAULT_COUNTRY_ID;
				this.model.dateBirthPosStart = isDate(new Date(customer.data.dateBirthPosStart)) ?
					customer.data.dateBirthPosStart : format(subYears(new Date(), 18),
					'YYYY-MM-DD');
			} catch (err) {
				if (err.status === 405) {
					if (err.data.message === 'CUSTOMER_NOT_FOUND') {
						if (Number(this.model.documentType) === 4) {
							this.searchByMixin();
						} else {
							this.showNotification('El cliente no se encuentra registrado, complete los datos o continúe el proceso como un cliente anónimo',
								'primary');
						}
					}
				} else if (err.status === 404) {
					if (err.data.message === 'CUSTOMER_NOT_FOUND') {
						if (Number(this.model.documentType) === 4) {
							this.searchByMixin();
						} else {
							this.showNotification('El cliente no se encuentra registrado, complete los datos o continúe el proceso como un cliente anónimo',
								'primary');
						}
					}
				} else {
					this.cleanCustomer();
				}
			}
		}
	}

	async function searchCustomerByRoom() {
		const paramsCustomer = {
			codeRoom: this.roomFilter,
			idSubsidiary: this.subsidiary,
			date: format(new Date(), 'YYYY-MM-DD'),
		};
		if (this.roomFilter > 0) {
			try {
				const { data: booking } = await this.$http.get(`${process.env.PMS_URL}/bookings-room`,
					{ params: paramsCustomer });
				booking.data.customer.data.idRoom = booking.data.bookingRooms.data.id;
				booking.data.customer.data.countryId = booking.data.customer.data.country.data.id;
				booking.data.customer.data.dateBirthPosStart =
				isDate(new Date(booking.data.customer.data.dateBirthPosStart))
					? booking.data.customer.data.dateBirthPosStart : format(subYears(new Date(), 18),
					'YYYY-MM-DD');
				this.model = booking.data.customer.data;
				this.bookings[0] = booking.data;
			} catch (err) {
				this.cleanCustomer('by-room');
				if (err.status === 404) {
					this.showNotification('El número de habitación no existe o no pertenece a la sucursal seleccionada.', 'info');
				}
			}
		}
	}

	function setPaymentMethod(value) {
		this.saleCustomer.paymentMethod = this.paymentMethods.find(pm => pm.code
			=== value).name;
	}

	function setTypeDocument(value) {
		this.saleCustomer.typeDocument = this.documentTypes.find(dt => dt.documentType.code
			=== value).documentType.name;
		if (value !== 'FAC') {
			this.validateExoneration();
		} else {
			this.showError();
		}
	}

	function showError() {
		if (this.cantBilling) {
			this.showNotification('Para generar una factura es necesario tener el RUC o pasaporte del cliente.',
				'primary');
		} else {
			this.flagTaxes = true;
			this.validateExoneration(this.flagTaxes);
		}
	}

	function symbol() {
		const curSelected = this.currencies.find(cur => cur.id === this.currencySelected);
		if (curSelected) {
			return curSelected.symbol;
		}
		return '$';
	}

	function toggleIconBirthDate() {
		this.onChange = !this.modal.dateBirthPosStart;
	}

	function totalAmount() {
		const total = this.localSummaryRows.reduce((acum, row) =>
			acum + (row.subTotal * row.quantity), 0);
		const newTotal = total.toFixed(2);
		this.tip = (newTotal * 0.05).toFixed(2);
		return newTotal;
	}

	function updateProducts(products) {
		products.forEach((rd) => {
			this.validateExoneration();
			const newRd = { ...rd };
			const discount = 1 - (Number(newRd.discount) / 100);
			newRd.priceWithDiscount = Number(newRd.price) * discount;
			const calculateSubTotal = {
				USD: newRd.priceWithDiscount,
				PEN: newRd.priceWithDiscount * this.exchangeRate,
			};
			newRd.subTotal = twoDecimals(calculateSubTotal[this.currencySelected]);
			const summaryIndex = this.summaryRows.findIndex(sumRow => sumRow.id === rd.id);
			if (summaryIndex > -1) {
				this.summaryRows[summaryIndex].quantity =
					Number(this.summaryRows[summaryIndex].quantity) + Number(rd.quantity);
			} else {
				this.summaryRows.push(newRd);
			}
		});
		this.localSummaryRows = [...this.summaryRows];
	}

	function validateAmount() {
		const paysAmount = this.paysByTypePayment.reduce((acum, currentPay) =>
			acum + Number(currentPay.amount), 0);
		return Number(paysAmount) !== Number(this.totalAmount);
	}

	function validateExoneration(flag) {
		this.invalid = flag && this.localSummaryRows.some(lsr => lsr.flagIgvRequired);
		if (flag || this.saleModel.typeDocumentCode !== 'FAC') {
			this.localSummaryRows = [...this.summaryRows];
			this.addPays(this.paysByTypePayment);
		} else {
			this.localSummaryRows = this.summaryRows.map((sr) => {
				const newSr = { ...sr };
				let price = 0;
				if (this.currencySelected === 'USD') {
					if (sr.flagIgv && !sr.flagIgvRequired) {
						price = sr.price ? sr.price : sr.subTotal;
					} else {
						price = sr.price ? addLocalTaxes(sr.price) : addLocalTaxes(sr.subTotal);
					}
				}
				if (this.currencySelected === 'PEN') {
					if (sr.flagIgv && !sr.flagIgvRequired) {
						price = sr.priceSoles ? sr.priceSoles : Number(sr.price) * Number(this.exchangeRate);
					} else {
						price = sr.priceSoles
							? addLocalTaxes(sr.priceSoles)
							: addLocalTaxes(Number(sr.price) * Number(this.exchangeRate));
					}
				}
				newSr.subTotal = price;
				return newSr;
			});
			this.addPays(this.paysByTypePayment);
		}
		if (this.invalid) {
			this.showNotification('No se puede exonerar de impuestos esta venta porque uno o más productos han sido configurados con impuesto obligatorio.',
				'error');
		}
	}

	function validations() {
		const model = {
			documentType: {
				required,
			},
			email: {
				email,
			},
			lastname: {
				required: requiredIf(() => this.naturalPerson),
			},
			name: {
				required,
			},
			numDocument: {
				required,
			},
		};
		if (this.numDocumentLength > 0) {
			model.numDocument.maxLength = maxLength(this.numDocumentLength);
			model.numDocument.minLength = minLength(this.numDocumentLength);
		}
		return {
			model,
			saleCustomer: {
				paymentMethod: {
					required,
				},
				typeDocument: {
					required,
				},
			},
			roomFilter: {
				minValue: minValue(1),
				required,
			},
		};
	}

	function getCustomerData(customer) {
		this.model = customer.data;
		this.model.countryId = customer.data.country && customer.data.country.data.id ?
			customer.data.country.data.id : process.env.DEFAULT_COUNTRY_ID;
		this.model.dateBirthPosStart = isDate(new Date(customer.data.dateBirthPosStart)) ?
			customer.data.dateBirthPosStart : format(subYears(new Date(), 18),
			'YYYY-MM-DD');
		this.customerExist = true;
	}

	function notFoundCustomer(personalDocument) {
		this.customerExist = false;
		this.model = {
			address: '',
			cellPhone: '',
			checkIn: '',
			checkOut: '',
			civilStatus: 1,
			countryId: 0,
			dateBirthPosStart: format(subYears(new Date(), 18), 'YYYY-MM-DD'),
			documentType: personalDocument.documentType,
			email: '',
			flagLoyalty: false,
			gender: 1,
			idRoom: 0,
			lastname: '',
			name: '',
			numDocument: personalDocument.numDocument,
			phone: '',
			priceSoles: '',
		};
	}

	function data() {
		return {
			dateBirthPosStart: '',
			dateBirthPos: false,
			active: null,
			bookings: [],
			civilStatus: [
				{ id: 1, name: 'Soltero(a)' },
				{ id: 2, name: 'Casado(a)' },
				{ id: 3, name: 'Viudo(a)' },
				{ id: 4, name: 'Divorciado(a)' },
			],
			commentary: '',
			countries: [],
			currencies: [],
			currencySelected: '',
			tip: '',
			customerExist: false,
			customerId: null,
			dialog: false,
			documentNumber: '',
			documentTypes: [],
			exchangeRate: '',
			priceSoles: '',
			flagTaxes: false,
			items: [
				{ id: 1, title: 'Detalle de Huésped' },
				{ id: 2, title: 'Resumen de cuenta' },
			],
			invalid: false,
			genders: [
				{ id: 1, name: 'Hombre' },
				{ id: 2, name: 'Mujer' },
			],
			localProductsColumns: [
				{ id: 1, name: 'Fecha' },
				{ id: 2, name: 'Cod. Producto' },
				{ id: 3, name: 'Categoría' },
				{ id: 4, name: 'Nombre Producto' },
				{ id: 5, name: 'Cant.' },
				{ id: 6, name: 'Precio Producto' },
			],
			localSummaryRows: [],
			menuBirthDate: false,
			model: {
				address: '',
				cellPhone: '',
				checkIn: '',
				checkOut: '',
				civilStatus: 1,
				countryId: 0,
				documentType: 0,
				email: '',
				flagLoyalty: false,
				gender: 1,
				idRoom: 0,
				lastname: '',
				name: '',
				numDocument: '',
				phone: '',
				priceSoles: '',
			},
			onChange: null,
			paramsDocuments: {},
			paramsSummary: {
				page: 1,
				limit: 10,
				withTransfer: 1,
			},
			paymentMethods: [
				{ id: 1, code: 'CONTADO', name: 'Contado' },
			],
			paysByTypePayment: [],
			productCategory: 0,
			productWarehouse: 0,
			roomFilter: 0,
			rooms: [],
			roomTypeId: 0,
			saleCustomer: {
				paymentMethod: '',
				typeDocument: 'BOLETA',
				typePayment: '',
			},
			saleModal: false,
			saleModel: {
				paymentMethodCode: 'CONTADO',
				typeDocumentCode: 'BOL',
				typePaymentCode: '',
			},
			searchBy: 1,
			searchMethods: [
				{ id: 1, name: 'Nº de identificación' },
				{ id: 2, name: 'Nº de habitación' },
			],
			subsidiaries: [],
			subsidiary: 0,
			summaryColumns: [
				{ id: 1, name: 'Fecha', code: 'createdAt' },
				{ id: 2, name: 'Cod. Producto', code: 'code' },
				{ id: 3, name: 'Cant.', code: 'quantity' },
				{ id: 4, name: 'Nombre Producto', code: 'name' },
				{ id: 5, name: 'Precio Producto', code: 'price' },
				{ id: 6, name: '', code: '' },
			],
			summaryRows: [],
			typeDocuments: [],
			typePayments: [],
			typePaymentsSelected: [],
			anonymousCustomer: false,
		};
	}

	export default {
		name: 'pos',
		components: {
			PaymentDialog,
			TableRun,
			typeDocumentInput,
		},
		computed: {
			arrowIconStart,
			arrowIconBirth,
			billingActive,
			cantBilling,
			disableGenerateSale,
			disabledId,
			disabledSave,
			documentTypeName,
			nameLabel,
			nameMessage,
			naturalPerson,
			numDocumentLength,
			roomDisabled,
			roomsEmpty,
			saleDisabled,
			searchById,
			searchByRoom,
			symbol,
			totalAmount,
			validateAmount,
		},
		created,
		data,
		filters: {
			currency,
			parseDate,
			round,
		},
		methods: {
			postPreview,
			addPays,
			back,
			changeAmounts,
			changeIcon,
			cleanCustomer,
			cleanModel,
			closeSaleModal,
			deleteLocalProduct,
			downloadTicket,
			generateSale,
			getCustomerData,
			goToCheckout,
			goToSummary,
			loadCurrencies,
			loadExchangeRate,
			loadResources,
			loadSaleResources,
			notFoundCustomer,
			openProductsModal,
			openSaleModal,
			register,
			searchByMixin,
			searchCustomer,
			searchCustomerByRoom,
			setPaymentMethod,
			setTypeDocument,
			showError,
			toggleIconBirthDate,
			updateProducts,
			validateExoneration,
			goToTab,
		},
		mixins: mixin,
		validations,
	};
</script>

<style lang="scss" scoped>
	.bar-data {
		align-items: center;
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
		display: flex;
		height: 48px;
		justify-content: space-around;

		&-item {
			border-right: 1px solid map-get($colors, year-select);
			flex: 1 auto;
			padding: 0px 13px;

			&:last-child {
				border-right: 0px;
			}

			p {
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, fourteen);
				margin-bottom: 0px;

				span {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
				}
			}
		}
	}

	.label-title {
		color: map-get($colors, dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, fourteen);
	}

	.tabs {
		top: -57px;
	}

	.total-amount {
		color: map-get($colors, bg-chart);
		font-family: map-get($fonts, bold);
		font-size: 24px;
		text-transform: uppercase;
	}
</style>


// WEBPACK FOOTER //
// Pos.vue?08e1b792